import { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import koKR from 'antd/lib/locale/ko_KR';
import { Route, Switch, useHistory } from 'react-router-dom';
import NotFoundPage from '@/components/pages/common/NotFoundPage';
import PublicRoute from '@/routes/PublicRoute';
import ContractRoute from '@/routes/ContractRoute';
import CompanyRoute from '@/routes/CompanyRoute';
import TaxNoticeRoute from '@/routes/TaxNoticeRoute';
import AuthRoute from '@/routes/AuthRoute';
import { PATH_AUTH, PATH_COMPANY, PATH_CONTRACT, PATH_MAIN, PATH_SERVICE, PATH_TAX, PATH_TERMS } from '@/constants/constant';
import { useAppDispatch } from '@/store';
import { getMe } from '@/features/account/accountSlice';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import UserRoute from '@/routes/UserRoute';
import ServiceRoute from '@/routes/ServiceRoute';
import HomePage from '@/components/pages/home/HomePage';
import TermsRoute from '@/routes/TermsRoute';
import ManageRoute from '@/routes/ManageRoute';
import AdminRoute from '@/routes/AdminRoute';
import { fetchCompanyList, fetchCompanySolutionList } from '@/features/company/companySlice';
import BrowserOutdatedPage from '@/components/pages/common/BrowserOutdatedPage';
import { isIE } from 'react-device-detect';
import { Redirect } from 'react-router';

const App = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { user } = useSelector((state: RootState) => state.account);
  const { current: company } = useSelector((state: RootState) => state.company);

  useEffect(() => {
    if (!user) {
      dispatch(getMe());
    }
    if (user) {
      console.log(user);
      if (!company) {
        dispatch(fetchCompanyList());
      } else {
        dispatch(fetchCompanySolutionList({ companyId: company.base?.id }));
      }
    }
  }, [company, dispatch, history, user]);

  if (isIE) {
    return <BrowserOutdatedPage />;
  }

  return (
    <ConfigProvider locale={koKR}>
      <Switch>
        <PublicRoute exact path={PATH_MAIN} component={HomePage} />
        <Route path={PATH_AUTH} component={AuthRoute} />
        <Route path={PATH_TAX} component={TaxNoticeRoute} />
        <Route path={PATH_COMPANY} component={CompanyRoute} />
        <Route path={PATH_CONTRACT} component={ContractRoute} />
        <Route path={PATH_SERVICE} component={ServiceRoute} />
        <Route path="/manage" component={ManageRoute} />
        <Route path="/user" component={UserRoute} />
        <Route path="/admin" component={AdminRoute} />
        <PublicRoute exact path="/error/browser/outdated" component={BrowserOutdatedPage} />
        <Route path={PATH_TERMS} component={TermsRoute} />
        <Redirect to={PATH_MAIN} />
        <PublicRoute component={NotFoundPage} />
      </Switch>
    </ConfigProvider>
  );
};

export default App;
